import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Calendar from 'react-calendar/dist/cjs/Calendar.js';
import 'react-calendar/dist/Calendar.css';
import './createOrder.css'

import {
    Box,
    Button,
    CircularProgress,
    Stepper,
    Step,
    StepLabel,
    TextField,
    Typography,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
    ToggleButtonGroup,
    ToggleButton,
    Select,
    MenuItem,
} from '@mui/material';

import axios from 'axios';
import debounce from 'lodash.debounce';

const CreateOrder = () => {
    const navigate = useNavigate();
    const [pickupMode, setPickupMode] = useState('oneTime');
    const [pickupDays, setPickupDays] = useState([]);
    const [activeStep, setActiveStep] = useState(0);
    const [phoneNumber, setPhoneNumber] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [userExists, setUserExists] = useState(null);
    const [showRegisterFields, setShowRegisterFields] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [formData, setFormData] = useState({
        username: '',
        usertype: 'individual',
        email: '',
        address: '',
        materialDescription: '',
        images: [],
        date: null,
        time: null,
        startDate: null,
        endDate: null,
        userId: '',
        category: 'general scrap',
    });

    const debouncedPhoneCheck = debounce(async (number) => {

        if (number.startsWith("+91")) {
            number = number.replace(/^\+91\s?/, ""); 
        }

        // if (number.startsWith("+91 ")) {
        //     input = input.slice(3);
        // }

        setIsLoading(true);
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/admin/users/checkuser?phone=${number}`
            );
            const data = await response.json();
            setUserExists(data.exists);
            if (data.exists) {
                setFormData((prev) => ({ ...prev, userId: data.userId }));
                setFormData((prev) => ({ ...prev, usertype: data.usertype }));
            }
        } catch (error) {
            console.error('Error checking user:', error);
            setUserExists(false);
            alert('Failed to check user. Please try again.');
        } finally {
            setIsLoading(false);
        }

    }, 500);

    const handleDayClick = (value) => {
        const formatDate = (date) => {
            return date.toISOString().split("T")[0];
        };

        setFormData((prev) => {
            if (!prev.startDate || (prev.startDate && prev.endDate)) {
                return { ...prev, startDate: formatDate(value), endDate: null };
            } else {
                return { ...prev, endDate: formatDate(value) };
            }
        });
    };


    const isWithinRange = (date) => {
        return (
            formData.startDate &&
            formData.endDate &&
            date.getTime() >= new Date(formData.startDate).getTime() &&
            date.getTime() <= new Date(formData.endDate).getTime()
        );
    };

    const isPickupDay = (date) => {
        if (!formData.startDate || !formData.endDate || pickupDays.length === 0) return false;
        const dayName = date.toLocaleDateString("en-US", { weekday: "long" });
        return pickupDays.includes(dayName) && isWithinRange(date);
    };


    const handlePickupDaysChange = (event) => {
        setPickupDays(event.target.value);
    };

    const handlePhoneNumberChange = (e) => {
        let input = e.target.value;

        // if (input.startsWith("+91 ")) {
        //     input = input.slice(3);
        // }

        setPhoneNumber(input);
        setUserExists(null);
        setShowRegisterFields(false);
        debouncedPhoneCheck(input);
        console.log(input);
    };

    const validateStepOne = () => {
        return userExists || (
            formData.username.trim() !== '' &&
            formData.usertype.trim() !== '' &&
            phoneNumber.trim() !== ''
        );
    };

    const handleRegisterUser = async () => {
        const user = JSON.parse(sessionStorage.getItem("user"))
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/user/register`,
                {
                    createdBy: user._id,
                    username: formData.username,
                    usertype: formData.usertype,
                    phone: phoneNumber,
                    email: formData.email,
                    password: 'defaultPassword123',
                }
            );

            if (response.data.success) {
                console.log(response.data.user._id)
                setFormData((prev) => ({ ...prev, userId: response.data.user.id }));
                setFormData((prev) => ({ ...prev, usertype: response.data.user.usertype }));
                setDialogOpen(true);
                handleNext();
            }
        } catch (error) {
            console.error('Error registering user:', error);
            alert('Failed to register user. Please ensure all details are correct.');
        }
    };

    const handleOrderCreation = async () => {
        const token = JSON.parse(sessionStorage.getItem("accessToken"));
        const user = JSON.parse(sessionStorage.getItem("user"))

        try {
            const payload = {
                createdBy: user._id,
                pickupdate: formData.date || formData.startDate,
                pickuptime: formData.time,
                address: formData.address,
                category: formData.category,
                material: formData.materialDescription,
                scrapImages: formData.images,
            };

            if (pickupMode === "custom") {
                payload.pickupmode = pickupMode;
                payload.pickupenddate = formData.endDate;
                payload.weekdays = pickupDays;
            }

            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/user/scrap/${formData.userId}`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data.success) {
                alert("Order scheduled successfully!");
                navigate(`/admin/orderDetails/${response.data.orderId}`);
            }
        } catch (error) {
            console.error("Error scheduling order:", error);
            alert("Failed to schedule order. Please try again.");
        }
    };


    const handleNext = () => {
        if (activeStep === 0 && !validateStepOne()) {
            alert('Please fill in all required fields before proceeding.');
            return;
        }
        setActiveStep((prev) => prev + 1);
    };

    const handleBack = () => {
        setActiveStep((prev) => prev - 1);
    };

    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const base64String = reader.result.split(',')[1];
                resolve(base64String);
            }
            reader.onerror = (error) => reject(error);
        });
    };

    const handleShowRegisterFields = () => {
        setShowRegisterFields(true);
    };

    const handleImageUpload = async (e) => {
        const files = Array.from(e.target.files);
        const base64Images = await Promise.all(files.map((file) => convertToBase64(file)));

        setFormData((prev) => ({
            ...prev,
            images: [...prev.images, ...base64Images],
        }));
    };

    const handleUserTypeChange = (event, newUserType) => {
        if (newUserType !== null) {
            setFormData((prev) => ({ ...prev, usertype: newUserType }));
        }
    };

    const handlePickupTypeChange = (event, newPickupType) => {
        if (newPickupType !== null) {
            setPickupMode(newPickupType);
        }
    };

    return (
        <Box sx={{ maxWidth: 700, margin: 'auto', padding: 4 }}>
            <Button variant="outlined" color="secondary" onClick={() => navigate('/admin/getOrders')} sx={{ mt: 2 }}>
                Back to order list
            </Button>
            <Typography variant="h4" align="center" gutterBottom>
                Create Order
            </Typography>
            <Stepper activeStep={activeStep} alternativeLabel>
                <Step>
                    <StepLabel>Enter User Details</StepLabel>
                </Step>
                <Step>
                    <StepLabel>Order Details</StepLabel>
                </Step>
            </Stepper>

            {activeStep === 0 && (
                <Box mt={4}>
                    <TextField
                        fullWidth
                        label="Phone Number"
                        name="phoneNumber"
                        value={phoneNumber}
                        onChange={handlePhoneNumberChange}
                        margin="normal"
                        InputProps={{
                            endAdornment: isLoading && <CircularProgress size={20} />,
                        }}
                    />
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 2 }}>
                        {userExists === false && !showRegisterFields && (
                            <Typography color="error">
                                User doesn't exist
                            </Typography>
                        )}
                        {userExists === false && !showRegisterFields && (
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleShowRegisterFields}
                            >
                                Register User?
                            </Button>
                        )}
                    </Box>

                    {showRegisterFields && (
                        <>
                            <ToggleButtonGroup
                                color="primary"
                                value={formData.usertype}
                                exclusive
                                onChange={handleUserTypeChange}
                                aria-label="User Type"
                            >
                                <ToggleButton value="individual">INDIVIDUAL</ToggleButton>
                                <ToggleButton value="business">BUSINESS</ToggleButton>
                            </ToggleButtonGroup>
                            <TextField
                                fullWidth
                                label="Username"
                                name="username"
                                value={formData.username}
                                onChange={handleFormChange}
                                margin="normal"
                            />
                            <TextField
                                fullWidth
                                label="Email (Optional)"
                                name="email"
                                value={formData.email}
                                onChange={handleFormChange}
                                margin="normal"
                            />
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleRegisterUser}
                                sx={{ mt: 2 }}
                            >
                                Register
                            </Button>
                        </>
                    )}
                    {userExists && (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleNext}
                            sx={{ mt: 2 }}
                        >
                            Next
                        </Button>
                    )}
                </Box>
            )}

            {activeStep === 1 && (
                <Box mt={4}>
                    {formData.usertype === "business" ? (
                        <>
                            <ToggleButtonGroup
                                value={pickupMode}
                                exclusive
                                onChange={handlePickupTypeChange}
                                aria-label="pickup type"
                                sx={{ mb: 2 }}
                            >
                                <ToggleButton value="oneTime" aria-label="one-time">
                                    One Time
                                </ToggleButton>
                                <ToggleButton value="custom" aria-label="custom">
                                    Custom
                                </ToggleButton>
                            </ToggleButtonGroup>
                            <TextField
                                fullWidth
                                label="Pickup Address"
                                name="address"
                                value={formData.address || ""}
                                onChange={handleFormChange}
                                margin="normal"
                            />

                            {pickupMode === "custom" ? (
                                <div>
                                    <div style={{ display: "flex", alignItems: "flex-start", gap: "20px" }}>
                                        <Calendar
                                            onClickDay={handleDayClick}
                                            tileClassName={({ date, view }) => {
                                                if (view === "month") {
                                                    if (isPickupDay(date)) return "pickup-day-highlight";
                                                    if (isWithinRange(date)) return "range-highlight";
                                                }
                                                return null;
                                            }}
                                        />
                                        <div>
                                            <Typography variant="h6" gutterBottom>
                                                Pickup Duration:
                                            </Typography>
                                            <Typography variant="h6">
                                                {formData.startDate ? new Date(formData.startDate).toDateString() : "Not Set"} -{" "}
                                                {formData.endDate ? new Date(formData.endDate).toDateString() : "Not Set"}
                                            </Typography>
                                        </div>
                                    </div>


                                    <FormControl fullWidth>
                                        <Typography>Pickup Days</Typography>
                                        <Select
                                            multiple
                                            value={pickupDays}
                                            onChange={handlePickupDaysChange}
                                            renderValue={(selected) => selected.join(", ")}
                                        >
                                            {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map(
                                                (day) => (
                                                    <MenuItem key={day} value={day}>
                                                        {day}
                                                    </MenuItem>
                                                )
                                            )}
                                        </Select>
                                    </FormControl>
                                </div>
                            ) : (
                                <TextField
                                    fullWidth
                                    label="Select Date"
                                    name="date"
                                    type="date"
                                    value={formData.date || ""}
                                    onChange={handleFormChange}
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            )}
                            <TextField
                                fullWidth
                                label="Pickup Time"
                                name="time"
                                type="time"
                                value={formData.time || ""}
                                onChange={handleFormChange}
                                margin="normal"
                            />

                            <FormControl component="fieldset">
                                <RadioGroup
                                    row
                                    name="category"
                                    value={formData.category}
                                    onChange={handleFormChange}
                                >
                                    <FormControlLabel value="general scrap" control={<Radio />} label="General Scrap" />
                                    <FormControlLabel value="vehicle scrap" control={<Radio />} label="Vehicle Scrap" />
                                    <FormControlLabel value="old cloth" control={<Radio />} label="Old Cloth" />
                                </RadioGroup>
                            </FormControl>

                            <TextField
                                fullWidth
                                label="Material Description"
                                name="materialDescription"
                                value={formData.materialDescription}
                                onChange={handleFormChange}
                                margin="normal"
                            />

                            <Button
                                variant="contained"
                                color="success"
                                fullWidth
                                onClick={handleOrderCreation}
                                sx={{ mt: 2 }}
                            >
                                Create Order
                            </Button>
                            <Button variant="contained" color="primary" onClick={handleBack} sx={{ mt: 2 }}>
                                Back To Step 1
                            </Button>
                        </>
                    ) : (
                        <>
                            <TextField
                                fullWidth
                                label="Pickup Date"
                                name="date"
                                type="date"
                                value={formData.date || ""}
                                onChange={handleFormChange}
                                margin="normal"
                            />
                            <TextField
                                fullWidth
                                label="Pickup Time"
                                name="time"
                                type="time"
                                value={formData.time || ""}
                                onChange={handleFormChange}
                                margin="normal"
                            />
                            <TextField
                                fullWidth
                                label="Pickup Address"
                                name="address"
                                value={formData.address}
                                onChange={handleFormChange}
                                margin="normal"
                            />
                            <FormControl component="fieldset">
                                <RadioGroup
                                    row
                                    name="category"
                                    value={formData.category}
                                    onChange={handleFormChange}
                                >
                                    <FormControlLabel value="general scrap" control={<Radio />} label="General Scrap" />
                                    <FormControlLabel value="vehicle scrap" control={<Radio />} label="Vehicle Scrap" />
                                    <FormControlLabel value="old cloth" control={<Radio />} label="Old Cloth" />
                                </RadioGroup>
                            </FormControl>
                            <TextField
                                fullWidth
                                label="Material Description"
                                name="materialDescription"
                                value={formData.materialDescription}
                                onChange={handleFormChange}
                                margin="normal"
                            />
                            <Button variant="contained" component="label" fullWidth sx={{ mt: 2 }}>
                                Upload Images
                                <input type="file" multiple hidden onChange={handleImageUpload} />
                            </Button>
                            <Box mt={2}>
                                {formData.images.map((img, index) => (
                                    <Typography key={index}>Image {index + 1} uploaded</Typography>
                                ))}
                            </Box>
                            <Button
                                variant="contained"
                                color="success"
                                fullWidth
                                onClick={handleOrderCreation}
                                sx={{ mt: 2 }}
                            >
                                Create Order
                            </Button>
                            <Button variant="outlined" color="secondary" onClick={handleBack} sx={{ mt: 2 }}>
                                Back To Step 1
                            </Button>
                        </>
                    )}
                </Box >
            )}

            <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
                <DialogTitle>User Registered</DialogTitle>
                <DialogContent>
                    <DialogContentText>User registered successfully!</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDialogOpen(false)} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default CreateOrder;
